export default function(data, filename, type, isImage) {
  // http://stackoverflow.com/questions/13405129
  var a = document.createElement("a"),
    file = new Blob([data], { type: type });
  // https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
  if (window.navigator.msSaveOrOpenBlob)
    // IE10+
    window.navigator.msSaveOrOpenBlob(file, filename);
  else {
    // Others
    var url = isImage ? data : URL.createObjectURL(file);
    a.href = url;
    //"download" is a native HTML5 "A" attribute
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}
